<template>
  <div class="warning-banner"
       :class="{'warning-banner--sticky': assignmentLink}">
    <div class="warning-banner__content">
      <p v-html="message"></p>
      <router-link v-if="assignmentLink"
                   :to="assignmentLink"
                   class="warning-banner__link">{{ linkText }}</router-link>
    </div>
    <button class="warning-banner__close-btn"
            @click="closeBanner"></button>
  </div>
</template>

<script>
  export default {
    props: {
      assignmentLink: {
        type: String,
        default: ''
      },
      message: {
        type: String,
        default: ''
      }
    },
    computed: {
      linkText() {
        return this.$gettext('Go to assignment');
      }
    },
    methods: {
      closeBanner() {
        localStorage.removeItem('dangerousFieldsEditedValues');
        localStorage.removeItem('unfinishedEditingJob');
        this.$router.push(this.$makeRoute({name: 'BuyerHome'}));
        setTimeout(() => {
          window.location.reload();
        }, 100);
      }
    }
  };
</script>

<style scoped>
.warning-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 15px;
  padding: 15px 15px 15px 45px;
  border: 1px solid #fede93;
  border-radius: 8px;
  background-color: #fffaed;
  background-image: url(~@assets/imgs/salita/undefined_imgs/warning_icon.svg);
  background-position: 17px center;
  background-size: 17px;
  background-repeat: no-repeat;
  color: #333;
  font-size: 14px;
  line-height: 20px;
  word-break: normal;
}

.warning-banner__content {
  display: flex;
}

.warning-banner--sticky {
  position: sticky;
  top: 70px;
  z-index: 5;
}

.warning-banner__link {
  margin-left: 10px;
  font-weight: bold;
  text-decoration: underline;
}

.warning-banner__close-btn {
  min-width: 14px;
  min-height: 14px;
  margin-left: 15px;
  background-image: url(~@assets/imgs/salita/dashboard_icons/close_x_mobile.svg);
  background-position: center center;
}
</style>
